
// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'ume-table';
const tableMaxHeigh = '25rem';
const dataTdAttr = 'data-table-head';
const tableWrapper = '.wp-block-table';
const tableBreakpoint = '779px';


// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class tableMobile {
  constructor(el) {
    this.el = el;
    this.$table = jQuery(el).find('table');
    this.$tbody = jQuery(el).find('tbody');
    this.$tableHead = jQuery(el).find('thead');
    this.$tableHeadTh = jQuery(el).find('thead th');
    this.$tbodyTr = jQuery(el).find('tbody tr');
    this.$tbodyTd = jQuery(el).find('tbody tr td');
    this.$button = jQuery(el).find('button');
    this.$blockTable = jQuery(el).find(tableWrapper);
    this.$collapseParent = jQuery(el).closest('.collapse');

    this.mediaMatcher = window.matchMedia(`(max-width: ${tableBreakpoint})`);

    this.fillTbodyAttr();
    if(this.mediaMatcher.matches){
      this.showButton();
    }

    if (this.$collapseParent.length) {
      this.$collapseParent.on('shown.bs.collapse', () => {
        this.showButton(this.mediaMatcher.matches ? 1 : 0);
      });
    }

    if (this.$button.length === 0) return;

    jQuery(this.$button).on('click', (item) => {
      if (item.target.classList.contains('is-open')) {
        item.target.classList.remove('is-open');
        this.$table[0].parentNode.style.maxHeight = tableMaxHeigh;
        this.$button[0].innerText = 'Alle anzeigen';
      } else {
        const tableHeight = this.$table.outerHeight(true);
        item.target.classList.add('is-open');
        this.$table[0].parentNode.style.maxHeight = `${tableHeight}px`;
        this.$button[0].innerText = 'Weniger anzeigen';
      }
    });

    this.mediaMatcher.addEventListener('change', (event) => {
      if (event.matches) {
        this.showButton(1);
      } else {
        this.$table[0].parentNode.style.maxHeight = '';
        this.showButton(0);
      }
    });
  }

  fillTbodyAttr() {
    if (this.$tableHead.length === 0) return;

    for (const itemTr of this.$tbodyTr) {
      let index = 1;

      for (const itemTd of itemTr.querySelectorAll('td')) {
        const getHeadText = this.$tableHead.find(`th:nth-child(${index})`).text();
        itemTd.setAttribute(dataTdAttr, getHeadText);
        index++
      }
    }
  }

  showButton(status) {
    if (status == 0) {
      this.$button.removeClass('show-more-table--visible');
    } else {
      const tableHeight = this.$tbody.height();

      if (tableHeight >= 400) { //400 entspricht 25rem
        this.$button.addClass('show-more-table--visible');
      } else {
        this.$button.removeClass('show-more-table--visible');
      }
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  jQuery(`.${baseClass}`).each((i, el) => new tableMobile(el));
}

// -------------------------------------------------------------------------------------------------
// Run
// -------------------------------------------------------------------------------------------------

init();

document.addEventListener('customUmeEvent', () => {
    init();
});